import React from 'react';
import {
	FieldErrors,
	FieldValues,
	UseFormRegister,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';
import { InputEmail } from '@/components/form';

interface Props {
	errors: FieldErrors<FieldValues>;
	watch: UseFormWatch<FieldValues>;
	register: UseFormRegister<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
}

export const PaypalForm: React.FC<Props> = ({ register, errors, setValue }) => {
	return (
		<>
			<InputEmail
				title="Email"
				placeholder="Ex: norma.lauren@gmail.com"
				name="paypalEmail"
				register={register}
				error={errors.paypalEmail}
				setValueCustom={setValue}
			/>
		</>
	);
};
